import api from "./api";

const AUDIT_TRAIL_END_POINT = "/audit-trails";
const OPTION_ROWS_END_POINT = "/option-rows";
const PRODUCTS_END_POINT = `${AUDIT_TRAIL_END_POINT}/products`;
const FILTERS_END_POINT = `${AUDIT_TRAIL_END_POINT}/filters`;
const TABLE_FILTERS_END_POINT = `${AUDIT_TRAIL_END_POINT}/table-filters`;
const FILTERS_SEARCH_END_POINT = `${AUDIT_TRAIL_END_POINT}/filters-search`;
const DELETE_AUDIT_TRAIL_END_POINT = `${AUDIT_TRAIL_END_POINT}/delete`;

export const fetchAdditionalData = async (rowSelectedInfo) => {
  return await api.get(
    `${OPTION_ROWS_END_POINT}/${rowSelectedInfo?.summary_id}/additional-info`
  );
};

export const fetchTrailData = async (queryParams) => {
  return await api.get(`${AUDIT_TRAIL_END_POINT}?`, { ...queryParams });
};

export const fetchAuditTrailPages = async (id, queryParams) => {
  return await api.get(`${AUDIT_TRAIL_END_POINT}/${id}`, { ...queryParams });
};

export const fetchProducts = async () => {
  return await api.get(PRODUCTS_END_POINT);
};

export const getFilterButtons = async () => {
  return await api.get(FILTERS_END_POINT);
};

export const getAuditTrailTableFilters = async () => {
  return await api.get(TABLE_FILTERS_END_POINT);
};

export const searchAuditTrailUins = async ({ uin } = {}) => {
  return await api.get(FILTERS_SEARCH_END_POINT, { uin });
};

export const deleteAuditTrailRow = async (audit_trail_id) => {
  return await api.post(DELETE_AUDIT_TRAIL_END_POINT, {
    audit_trail_id: audit_trail_id,
  });
};
